"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { WorkspaceElementType } from '@membranehq/sdk';
import { useElement } from '../element/useElement.mjs';

function useFieldMapping(selector) {
  const {
    item: fieldMapping,
    accessor,
    refresh,
    ...rest
  } = useElement(
    WorkspaceElementType.FieldMapping,
    selector,
    (integrationApp) => selector ? integrationApp.fieldMapping(selector) : void 0
  );
  async function reset() {
    await accessor?.reset();
    await refresh();
  }
  async function setup() {
    await accessor?.setup();
    await refresh();
  }
  return { fieldMapping, reset, setup, refresh, accessor, ...rest };
}

export { useFieldMapping };
